import React from 'react';
import { styled } from 'linaria/react';
import { ReactComponent as Search } from '../../../svg/Search.svg';
import { ReactComponent as Check } from '../../../svg/Check.svg';
import ColorsAndTextilesConfig from '../Config/colorsAndTextiles.config';

const TextileButton3D = styled('div')`
    cursor: pointer;
  &.active {
    
  }

  @media screen and (max-width: 1024px) {
    width: 175px;
    display: flex;
    flex-direction: column;
    position: relative;
    max-width: unset;
  }

  @media screen and (max-width: 800px) {
    width: 150px;
  }
`

const TextileButton3DBackground = styled('div')`
  width: 100%;
  border-radius: 8px;
  position: relative;

`

const TextileButton3DBackgroundImage = styled('img')`
  width: 100%;
  min-height: 125px;
  border-radius: 8px;
  position: relative;
  max-height: 125px;
  aspect-ratio: 1 / 1;

  @media screen and (max-width: 1023px) {
    width: 100%;
    height: auto;
  }

  @media screen and (max-width: 800px) {
    width: 150px;
    height: auto;
    max-height: unset;
    aspect-ratio: 1 / 1;
  }
`

const TextileButton3DText = styled('p')`
  font-size: 16px;
  font-weight: 500;
  color: #222;
  margin: 0;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`

const TextileButton3DName = styled('span')`
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  line-height: 1.1;
 `

const TextileButton3DSubtitle = styled('span')`
  font-size: 14px;
  font-weight: 400;
  color: #222;
  margin: 0;
  display: flex;
  width: 100%;
  text-align: left;
`

const TextileButtons = styled('div')`
  position: absolute;
  bottom: 15px;
  width: calc(100% - 30px);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  left: 15px;
`

const TextileButtonsCheck = styled('div')`
  background: #fff;
  padding: 3px;
  border-radius: 999px;
  width: 25px;
  height: 25px;
  justify-content: center;
  align-items: center;
  display: flex;
  opacity: 0;
  &.active {
    opacity: 1;
  }
    svg {
      path {
        fill: #000;
      }
    }
`
const TextileButtonsMagnify = styled('div')`
  background: #fff;
  padding: 3px;
  border-radius: 999px;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 2;
`

const findTextileByName = (name) => {
  return ColorsAndTextilesConfig.textiles.find(item => item.name === name);
}

export const Textile3D = ({textile, active, onClick, openTextile, setOpenTextile}) => {
  const textileData = findTextileByName(textile.name);
  if (!textileData || !textileData.smallImage || !textileData.publicName) {
    return '';
  }

  return <>
    <TextileButton3D active={active !== null ? 1 : 0} onClick={onClick}>
      <TextileButton3DBackground>
        <TextileButton3DBackgroundImage src={textileData.smallImage} alt={textile.publicName} />
        <TextileButtons>
          <TextileButtonsCheck className={active ? 'active' : ''}><Check /></TextileButtonsCheck>
          <TextileButtonsMagnify onClick={() => { setOpenTextile(true); }}>
            <Search />
          </TextileButtonsMagnify>
        </TextileButtons>
      </TextileButton3DBackground>
      <TextileButton3DText>
        <TextileButton3DName>{textileData.publicName}</TextileButton3DName>
        <TextileButton3DSubtitle>{textileData.fabric}</TextileButton3DSubtitle>
      </TextileButton3DText>
    </TextileButton3D>
  </>
}